import React from 'react';
import { Grid } from '@material-ui/core';
import { MissingAnnotationEmptyState, Page, Content, ContentHeader, SupportButton } from '@backstage/core-components';
import { SecurityInsightsTable } from '../SecurityInsightsTable/SecurityInsightsTable.esm.js';
import { GITHUB_REPO_ANNOTATION } from '../useProjectName.esm.js';
import { useEntity } from '@backstage/plugin-catalog-react';

const isSecurityInsightsAvailable = (entity) => Boolean(entity.metadata.annotations?.[GITHUB_REPO_ANNOTATION]);
const SecurityInsightsTab = () => {
  const { entity } = useEntity();
  if (!isSecurityInsightsAvailable(entity)) {
    return /* @__PURE__ */ React.createElement(MissingAnnotationEmptyState, { annotation: GITHUB_REPO_ANNOTATION });
  }
  return /* @__PURE__ */ React.createElement(Page, { themeId: "tool" }, /* @__PURE__ */ React.createElement(Content, null, /* @__PURE__ */ React.createElement(ContentHeader, { title: "Security Insights" }, /* @__PURE__ */ React.createElement(SupportButton, null, "Plugin to show Security Insights")), /* @__PURE__ */ React.createElement(Grid, { container: true, spacing: 3, direction: "column" }, /* @__PURE__ */ React.createElement(Grid, { item: true }, /* @__PURE__ */ React.createElement(SecurityInsightsTable, null)))));
};

export { SecurityInsightsTab, isSecurityInsightsAvailable };
//# sourceMappingURL=SecurityInsightsTab.esm.js.map
